// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_el4","cls2":"ProfileDropdown-cls2_l_m ProfileDropdown-cls1_el4"};